import {httpClient} from "./index";

class CrmService {

    constructor(httpClient) {
        this.httpClient = httpClient;
    }

    async findAllServicesByIds(key, id) {
        if (id){
            return await this.httpClient.get(`/api/all/${key}/${id}`);

        }else{
            return await this.httpClient.get(`/api/all/${key}`);
        }
    }

    async findOneServiceByIds(key, id) {
        return await httpClient.get(`/api/${key}/${id}`);
    }

    async getTicketPdf(id, options = {}) {
        return await httpClient.get(`/api/ticket-file/purchase/${id}`, {
            responseType: 'blob',
            ...options,
        });
    }

    async postDataToTicketsOptions(type, data) {
        return await httpClient.post(`/api/create/${type}`, data);
    }


    async updateDataInDb(type, data) {
        return await httpClient.post(`/api/update/${type}`, data);
    }


    async postDataToTickets(data) {
        console.log(data)
        return await httpClient.post(`/api/create/ticket`, data);
    }

    async deleteDataInDB(type, id) {
        const body = { _id: id }
        return await httpClient.post(`/api/delete/${type}`, body);
    }

    async getWidgetCode(data, isOneTicket) {
        console.log(data)
        if (isOneTicket){
            return await httpClient.get(`/api/ticket-widget/ticket/${data}`);

        } else {
            return await httpClient.get(`/api/ticket-widget/event/${data}`);

        }
    }

    async getStripeSetting() {
        return await httpClient.get(`/api/stripe-settings`);
    }

    async postStripeSecrets(data) {
        await httpClient.post(`/api/update/user`, data);
    }

    async findTicket(id) {
        const ticket =  await httpClient.get(`/api/one-ticket/${id}`);
        const { data } = ticket;
        if (data.redirect) {
            window.location.href = data.redirect;
            return;
        }
        return ticket;
    }

    async findOrder(order_id) {
        const ticket =  await httpClient.get(`/api/purchase-ticket/${order_id}`);
        console.log(ticket)
        return ticket;
    }
}

export default CrmService;
